import React from "react";
import './footer.css'
import logo from './media/codebird_logo.png'
import discord from './media/discord.png'
import linkedin from './media/linkedin.png'
import instagram from './media/intsagram.png'
import twitter from './media/twitter.png'

const Footer = () => {
    return (
        <div className="footer">


            <div className="footer_up">
                <img src={logo} alt="Logo" />
                <div>
                    <div className="address">
                        <h2>V E N U E</h2>
                        <p>UIT, Golapbag, Burdwan, W.B.</p>
                    </div>

                    <div className="connect">
                        <p>
                            STAY  CONNECTED
                        </p>
                        <div className="icons">
                            <img src={discord} alt="discord" />
                            <img src={linkedin} alt="linkedin" />
                            <img src={twitter} alt="twitter" />
                            <img src={instagram} alt="instagram" />
                        </div>
                    </div>
                </div>
            </div>


            <div className="footer_bottom">
                <p>Copyright reserved to Codebird © 2023</p>
            </div>
        </div>
    )
}

export default Footer;